import React from "react";
import { useParams, useSearchParams, Navigate } from "react-router-dom";
import { useProfile } from "../context/ProfileContext";
import { gameById, regionById } from "../data/gameData";
import MultipleChoiceGame from "./MultipleChoiceGame";
import MemoryForge from "./MemoryForge";

export default function GamePlay() {
  const { gameType } = useParams();
  const [params] = useSearchParams();
  const { profile, loading } = useProfile();

  if (loading) return null;
  if (!profile) return <Navigate to="/" replace />;

  const game = gameById(gameType);
  if (!game) return <Navigate to="/map" replace />;

  const regionId = params.get("region");
  const tablesParam = params.get("tables");
  const region = regionId ? regionById(regionId) : null;
  let tables = region ? region.tables : null; // null => mixed 2-20
  let subtitle = region ? region.name : "Mixed · Tables 2–20";
  if (tablesParam) {
    tables = tablesParam.split(",").map((n) => parseInt(n, 10)).filter(Boolean);
    subtitle = tables.length === 1 ? `Practising the ${tables[0]}× table` : "Custom practice";
  }

  if (game.component === "memory") {
    return <MemoryForge tables={tables} subtitle={subtitle} />;
  }
  return <MultipleChoiceGame game={game} tables={tables} subtitle={subtitle} />;
}
